/**
 * @desc pathname을 정규화합니다 (trailing slash 제거)
 */
export const removeSlashPath = (path) => {
  if (!path) return '';
  return path.endsWith('/') && path !== '/' ? path.slice(0, -1) : path;
};

/**
 * // 경로에 따른 서비스 타입 매핑
 * @param {*} currentPath
 * @returns
 */
export const getServiceType = (currentPath) => {
  if (currentPath.includes('map')) return 'map';
  if (currentPath.includes('search')) return 'search';
  if (currentPath.includes('route')) return 'route';
  return null;
};
